import React, { useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Field, Formik } from 'formik'
import { Button, Form, FormGroup, Label, Modal, ModalBody } from 'reactstrap'
import { customInputForm } from 'ui/common'
import DropdownSelect from 'layout-components/Dropdown'
import { selectors } from 'features/dashboard'
import { createHeatMap } from 'features/dashboard/Map.actionTypes'

const HeatMapsModal = ({ modal, toggle, setImage }) => {
    const dispatch = useDispatch()
    const map = useSelector(selectors.getTeamMap)
    const tasks = useSelector(selectors.getTask)
    const initVehicles = useSelector(selectors.getVehicles)
    const colourSchemes = ['magma', 'viridis', 'plasma', 'inferno', 'twilight']
    const [mission, setMission] = useState(null)
    const [vehicles, setVehicles] = useState([])
    const [evenType, setEventType] = useState(null)
    const [colourScheme, setColourScheme] = useState(null)

    const dateInputRef = useRef(null)
    const dateInputRef2 = useRef(null)

    const toggleClose = () => {
        setMission(null)
        setVehicles([])
        setEventType(null)
        setColourScheme(null)
        toggle()
    }

    const triggerDatePicker = () => {
        if (dateInputRef.current) {
            dateInputRef.current.showPicker()
        }
    }

    const triggerDatePicker2 = () => {
        if (dateInputRef2.current) {
            dateInputRef2.current.showPicker()
        }
    }

    const handleSubmit = (values) => {
        const { uuid } = map?.areas
        const data = { ...values, vehicles: vehicles.map((vehicle) => vehicle.uuid) }

        dispatch(createHeatMap({ uuid, data })).then((res) => {
            if (res.error) return

            // const image = new window.Image()
            // image.src = res.payload.data
            setImage(res.payload.data)

            setMission(null)
            setVehicles([])
            setEventType(null)
            setColourScheme(null)
            toggle()
        })
    }

    return (
        <Modal isOpen={modal} toggle={toggleClose} centered size="lg" className="new-modals">
            <ModalBody
                className="py-0 my-0"
                style={{
                    padding: '24px',
                    position: 'relative',
                    overflowY: 'auto',
                    color: '#24272D',
                }}
            >
                <div className="modal-sticky-header  pt-4">
                    <div
                        className="w-100 d-flex justify-content-between"
                        style={{ marginBottom: '24px' }}
                    >
                        <img
                            src="/svgs/modal-icons/map-icon-modal.svg"
                            alt="obstacle-icon"
                            width="48px"
                            height="48px"
                        />
                        <img
                            src="/svgs/close-icon/x-dark-default.svg"
                            alt="obstacle-icon"
                            width="24px"
                            height="24px"
                            style={{ cursor: 'pointer' }}
                            onClick={toggle}
                        />
                    </div>
                    <div className="d-flex flex-column gap-4 mb-4">
                        <span
                            style={{
                                fontWeight: '500',
                                fontSize: '18px',
                                lineHeight: '24px',
                                letterSpacing: '0.2px',
                            }}
                        >
                            Create heat map
                        </span>
                        <span
                            style={{
                                fontWeight: '400',
                                fontSize: '16px',
                                lineHeight: '24px',
                                letterSpacing: '0.1px',
                            }}
                        >
                            Click “Create” to auto-generate a heat map for all vehicles of the
                            current map. If you’d like to customise your heat map, please choose
                            from the options below.
                        </span>
                    </div>
                </div>
                <Formik initialValues={{}} onSubmit={handleSubmit}>
                    {({ values, setFieldValue, handleSubmit }) => (
                        <Form
                            onSubmit={(e) => {
                                e.preventDefault()
                                handleSubmit(e)
                            }}
                            className="form-wrapper"
                        >
                                <FormGroup>
                                    <Label for="mission" className="modals-labels">
                                        Mission
                                    </Label>
                                    <DropdownSelect
                                        selected={mission}
                                        setSelected={setMission}
                                        setFieldValue={setFieldValue}
                                        fieldValue="mission"
                                        options={[' ', ...Object.values(tasks.listV2)]}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="vehicles" className="modals-labels">
                                        Vehicle(s)
                                    </Label>
                                    <DropdownSelect
                                        selected={vehicles}
                                        setSelected={setVehicles}
                                        setFieldValue={setFieldValue}
                                        fieldValue="vehicles"
                                        options={initVehicles.teamVehiclesLight.filter(
                                            (vehicle) =>
                                                !vehicles.some(
                                                    (selected) => selected.uuid === vehicle.uuid
                                                )
                                        )}
                                    />
                                    <div className="d-flex gap-2 mt-2">
                                        {vehicles.map((veh) => (
                                            <span
                                                key={veh.uuid}
                                                style={{
                                                    borderRadius: '16px',
                                                    padding: '2px 8px',
                                                    gap: '4px',
                                                    backgroundColor: '#EEF4FF',
                                                    fontWeight: '400',
                                                    fontSize: '12px',
                                                    lineHeight: '18px',
                                                    letterSpacing: '0.2px',
                                                    horizontalAlign: 'center',
                                                    verticalAlign: 'bottom',
                                                    color: '#175CD3',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                {veh.verbose_name}{' '}
                                                <img
                                                    src="/svgs/modal-icons/x.svg"
                                                    alt="x"
                                                    width="8px"
                                                    height="8px"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => {
                                                        const newVehicles = vehicles.filter(
                                                            (item) => item.uuid !== veh.uuid
                                                        )
                                                        setVehicles(newVehicles)
                                                    }}
                                                />
                                            </span>
                                        ))}
                                    </div>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="date" className="modals-labels">
                                        Custom timeline
                                    </Label>
                                    <div
                                        className="d-flex w-100 justify-content-start"
                                        style={{ gap: '48px' }}
                                    >
                                        <div className="d-flex align-items-center gap-2">
                                            <span>Start</span>
                                            <Field
                                                name="start_time"
                                                component={customInputForm}
                                                type="date"
                                                style={{ width: '206px' }}
                                                min="2020-01-01"
                                                max="2025-12-31"
                                                innerRef={dateInputRef}
                                                onClick={triggerDatePicker}
                                                className="modals-inputs"
                                            />
                                        </div>
                                        <div className="d-flex align-items-center gap-2">
                                            <span>Finish</span>
                                            <Field
                                                name="end_time"
                                                component={customInputForm}
                                                type="date"
                                                style={{ width: '206px' }}
                                                min="2020-01-01"
                                                max="2025-12-31"
                                                innerRef={dateInputRef2}
                                                onClick={triggerDatePicker2}
                                                className="modals-inputs"
                                            />
                                        </div>
                                    </div>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="event_type" className="modals-labels">
                                        Event type
                                    </Label>
                                    <DropdownSelect
                                        selected={evenType}
                                        setSelected={setEventType}
                                        setFieldValue={setFieldValue}
                                        fieldValue="event_type"
                                        options={[
                                            { uuid: 'dynamic', title: 'Dynamic' },
                                            { uuid: 'static', title: 'Static' },
                                        ]}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="colour_scheme" className="modals-labels">
                                        Colour scheme
                                    </Label>
                                    <DropdownSelect
                                        selected={colourScheme}
                                        setSelected={setColourScheme}
                                        setFieldValue={setFieldValue}
                                        fieldValue="colour_scheme"
                                        options={colourSchemes.map((item) => ({
                                            uuid: item,
                                            title: item.charAt(0).toUpperCase() + item.slice(1),
                                        }))}
                                    />
                                </FormGroup>
                            
                            <div
                                style={{ marginTop: '24px' }}
                                className="d-flex w-100 justify-content-between align-items-center sticky-modal-footer"
                            >
                                <Button
                                    color="none"
                                    onClick={toggleClose}
                                    className="cancel-btn-modal modals-new-btns mr-2"
                                >
                                    Cancel
                                </Button>

                                <Button type="submit" className="save-btn-modal modals-new-btns">
                                    Create
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </ModalBody>
        </Modal>
    )
}

export default HeatMapsModal
